export interface IJpClassType {
  id: number;
  name: string | null;
  signupMax: number | null;
  allowMultiple: boolean;
  prerequisite: number | null;
  sessionLength: number | null;
  sessionCount: number | null;
  ratingOverkill: number | null;
  minAge: number | null;
  maxAge: number | null;
  minSessionsForAttended: number | null;
  active: boolean | null;
  displayOrder: number | null;
  noLimit: boolean | null;
}

export class JpClassType implements IJpClassType {
  id;
  name;
  signupMax;
  allowMultiple;
  prerequisite;
  sessionLength;
  sessionCount;
  ratingOverkill;
  minAge;
  maxAge;
  minSessionsForAttended;
  active;
  displayOrder;
  noLimit;

  constructor(config: IJpClassType) {
    this.id = config.id;
    this.name = config.name;
    this.signupMax = config.signupMax;
    this.allowMultiple = config.allowMultiple;
    this.prerequisite = config.prerequisite;
    this.sessionLength = config.sessionLength;
    this.sessionCount = config.sessionCount;
    this.ratingOverkill = config.ratingOverkill;
    this.minAge = config.minAge;
    this.maxAge = config.maxAge;
    this.minSessionsForAttended = config.minSessionsForAttended;
    this.active = config.active;
    this.displayOrder = config.displayOrder;
    this.noLimit = config.noLimit;
  }
}
